import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import CenterOfferAuthorizedSignatoryStaffPanel from '../../../widgets/centerOfferAuthorizedSignatoryStaff/CenterOfferAuthorizedSignatoryStaffPanel'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSignContract } from '../../../redux/actions/contract'
import ContractSignTypeWidgets from '../../../widgets/ContractSignType/ContractSignTypeWidgets'

export default function CenterOfferAuthorizedSignatory() {
  //ขั้นที่ 3 เสนอผู้มีอำนาจลงนาม
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSignContract(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema.forms?.contractInfo && (
          <ContractSignTypeWidgets schema={schema.forms?.contractInfo || null} />
        )}

        {schema?.forms?.requestNote?.note && (
          <CenterOfferAuthorizedSignatoryStaffPanel
            showCommandButton={!schema.forms.requestNote.disabled}
            schema={schema?.forms?.requestNote}
          />
        )}
      </SidebarProposal>
    </>
  )
}
